// import Head from 'next/head'
// import * as Accordion from '@radix-ui/react-accordion'
// import ArrowDown from '@/assets/common/arrowDown.inline.svg'
import isEmpty from 'lodash/isEmpty'

import { StrapiRichTextStyles } from '@/revamp/pods/strapi/components/strapi-rich-text-editor-styles'
import Accordion from '@/components/Payments/common/Accordion'
import { populateHandleBarLikeTemplatesWithData } from '@/revamp/utils/string/handlebar-like-string-template-populate'

type Props = {
  question: string
  answer: string
  json_placeholder?: object
}

const questionSchemaProps = {
  itemScope: true,
  itemProp: 'mainEntity',
  itemType: 'https://schema.org/Question',
}

const answerSchemaProps = {
  itemScope: true,
  itemProp: 'acceptedAnswer',
  itemType: 'https://schema.org/Answer',
}

export function StrapiV4FAQ(props: Props) {
  const { question, answer, json_placeholder = {} } = props

  const massagedAnswer = isEmpty(json_placeholder)
    ? answer
    : populateHandleBarLikeTemplatesWithData(answer, json_placeholder)

  return (
    <div {...questionSchemaProps}>
      <Accordion
        title={question}
        isOpen={true}
        isFAQ
        hTag="h3"
        wrapperClass="!border-0 !shadow-none !border-b-1 !rounded-none !p-0"
        titleClass="flex w-full py-4 text-left md:text-xl lg:py-5"
      >
        <div {...answerSchemaProps}>
          <div itemProp="text">
            <StrapiRichTextStyles>
              <div
                dangerouslySetInnerHTML={{
                  __html: massagedAnswer,
                }}
              />
            </StrapiRichTextStyles>
          </div>
        </div>
      </Accordion>
    </div>
  )

  // return (
  //   <>
  //     <Head>
  //       <style
  //         dangerouslySetInnerHTML={{
  //           __html: `
  //           .accordion-trigger[data-state='open'] > .accordion-chevron {
  //             transform: rotate(180deg);
  //           }
  //         `,
  //         }}
  //         id="accordion-chevron-styles"
  //         key="accordion-chevron-styles"
  //       />
  //     </Head>

  //     <Accordionz.Item value={question}>
  //       <Accordionz.Header {...questionSchemaProps}>
  //         <Accordionz.Trigger
  //           className="accordion-trigger border-b-1 border-brand-grey-light flex w-full py-4 text-left text-2xl font-medium lg:py-5"
  //           itemProp="name"
  //         >
  //           {question}
  //           <span className="accordion-chevron ml-auto">
  //             <ArrowDown className="h-6 w-6" />
  //           </span>
  //         </Accordionz.Trigger>
  //       </Accordionz.Header>

  //       <Accordionz.Content
  //         className="accordion-content p-2"
  //         {...answerSchemaProps}
  //       >
  //         <div itemProp="text">
  //           {' '}
  //           <StrapiRichTextStyles>
  //             <div
  //               dangerouslySetInnerHTML={{
  //                 __html: answer,
  //               }}
  //             />
  //           </StrapiRichTextStyles>
  //         </div>
  //       </Accordionz.Content>
  //     </Accordionz.Item>
  //   </>
  // )
}
